import { useQuery } from "@tanstack/react-query";

export async function getDatasetById({
  callApiWithWorker,
  id,
  language,
  signal,
}) {
  const url =
    `/datasets/${encodeURIComponent(id)}` +
    `?lang=${encodeURIComponent(language)}`;

  return callApiWithWorker(url, { method: "GET", signal });
}

export function useGetDatasetById({
  callApiWithWorker,
  id,
  language,
  enabled,
}) {
  return useQuery({
    queryKey: ["dataset", id, language],
    enabled: Boolean(enabled && id),
    queryFn: ({ signal } = {}) =>
      getDatasetById({ callApiWithWorker, id, language, signal }),
    staleTime: 30_000,
  });
}
